import { render, staticRenderFns } from "./FieldServiceWorkOrder.vue?vue&type=template&id=198e37b5&scoped=true"
import script from "./FieldServiceWorkOrder.vue?vue&type=script&lang=js"
export * from "./FieldServiceWorkOrder.vue?vue&type=script&lang=js"
import style0 from "./FieldServiceWorkOrder.vue?vue&type=style&index=0&id=198e37b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198e37b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
